import { useGameSounds } from "@educaplay/core";
import { Draggable } from "../Draggable";
import { Word } from '../Word';
import { motion } from 'framer-motion';
import { COMPLETAR_SOUNDS } from "../../utils/constants";

export const DraggableWord = (props) => {
    const { word, styles={}, place, onClick, origin, isDragging, animationStatus } = props;

    const gameSounds = useGameSounds();

    if (!word) return

    const introVariants = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
        }
    }

    return (
        <Draggable
            key={word.id}
            id={word.id}
            styles={{background: 'none', display: 'inline-flex'}}
            onClick={onClick}
            origin={origin}
            isDragging={isDragging}
        >
            <motion.span
                variants={introVariants}
                style={{display: 'inline-flex'}}
                initial="show"
                onMouseEnter={() => gameSounds.play(COMPLETAR_SOUNDS.HOVER)}
            >
                <span style={{transform: `rotate(${isDragging ? 7 : 0}deg)`, display: 'inline-flex'}} >
                    <Word word={word} styles={styles} place={place} mode={'dnd'} animationStatus={animationStatus}  />
                </span>
            </motion.span>
        </Draggable>
    )
}